import { render, staticRenderFns } from "./clientCart.vue?vue&type=template&id=4c05f0a0&"
import script from "./clientCart.vue?vue&type=script&lang=js&"
export * from "./clientCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports